// extracted by mini-css-extract-plugin
export default {"large-profile-image-wrapper":"large-profile-image-wrapper-fc9d","image":"image-680a","on-click-listener":"on-click-listener-16aa"};